// wp-icons — Business & Tools (15)
import { createWpIcon } from './createIcon.js';

export const Briefcase = createWpIcon('Briefcase', [
  ['rect', { width: 20, height: 14, x: 2, y: 7, rx: 2, ry: 2, key: 'a' }],
  ['path', { d: 'M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16', key: 'b' }],
]);
export const Building2 = createWpIcon('Building2', [
  ['path', { d: 'M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z', key: 'a' }],
  ['path', { d: 'M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2', key: 'b' }],
  ['path', { d: 'M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2', key: 'c' }],
  ['path', { d: 'M10 6h4', key: 'd' }],
  ['path', { d: 'M10 10h4', key: 'e' }],
  ['path', { d: 'M10 14h4', key: 'f' }],
  ['path', { d: 'M10 18h4', key: 'g' }],
]);
export const Package = createWpIcon('Package', [
  ['path', { d: 'm7.5 4.27 9 5.15', key: 'a' }],
  ['path', { d: 'M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z', key: 'b' }],
  ['path', { d: 'M3.3 7 12 12l8.7-5', key: 'c' }],
  ['path', { d: 'M12 22V12', key: 'd' }],
]);
export const Truck = createWpIcon('Truck', [
  ['path', { d: 'M10 17h4V5H2v12h3', key: 'a' }],
  ['path', { d: 'M14 17h5l3-4v-3a1 1 0 0 0-1-1h-4', key: 'b' }],
  ['circle', { cx: 7.5, cy: 17.5, r: 2.5, key: 'c' }],
  ['circle', { cx: 17.5, cy: 17.5, r: 2.5, key: 'd' }],
]);
export const Plane = createWpIcon('Plane', [
  ['path', { d: 'M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z', key: 'a' }],
]);
export const Ruler = createWpIcon('Ruler', [
  ['path', { d: 'M21.3 8.7 8.7 21.3a2.4 2.4 0 0 1-3.4 0L2.7 18.7a2.4 2.4 0 0 1 0-3.4L15.3 2.7a2.4 2.4 0 0 1 3.4 0l2.6 2.6a2.4 2.4 0 0 1 0 3.4Z', key: 'a' }],
  ['path', { d: 'm7.5 10.5 2 2', key: 'b' }],
  ['path', { d: 'm10.5 7.5 2 2', key: 'c' }],
  ['path', { d: 'm13.5 4.5 2 2', key: 'd' }],
  ['path', { d: 'm4.5 13.5 2 2', key: 'e' }],
]);
// Wrench moved to craft.js (WerkPilot handwerks-kategorie)
export const Puzzle = createWpIcon('Puzzle', [
  ['path', { d: 'M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.802-.48-.968-.925a2.501 2.501 0 1 0-3.214 3.214c.446.166.855.497.925.968a.979.979 0 0 1-.276.837l-1.61 1.61a2.404 2.404 0 0 1-1.705.707 2.402 2.402 0 0 1-1.704-.706l-1.568-1.568a1.026 1.026 0 0 0-.877-.29c-.493.074-.84.504-1.02.968a2.5 2.5 0 1 1-3.237-3.237c.464-.18.894-.527.967-1.02a1.026 1.026 0 0 0-.289-.877l-1.568-1.568A2.402 2.402 0 0 1 1.998 12c0-.617.236-1.234.706-1.704L4.23 8.77c.24-.24.581-.353.917-.303.515.077.877.528 1.073 1.01a2.5 2.5 0 1 0 3.259-3.259c-.482-.196-.933-.558-1.01-1.073-.05-.336.062-.676.303-.917l1.525-1.525A2.402 2.402 0 0 1 12 1.998c.617 0 1.234.236 1.704.706l1.568 1.568c.23.23.556.338.877.29.493-.074.84-.504 1.02-.968a2.5 2.5 0 1 1 3.237 3.237c-.464.18-.894.527-.967 1.02Z', key: 'a' }],
]);
export const Tag = createWpIcon('Tag', [
  ['path', { d: 'M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z', key: 'a' }],
  ['circle', { cx: 7.5, cy: 7.5, r: 0.5, fill: 'currentColor', key: 'b' }],
]);
export const Hash = createWpIcon('Hash', [
  ['line', { x1: 4, x2: 20, y1: 9, y2: 9, key: 'a' }],
  ['line', { x1: 4, x2: 20, y1: 15, y2: 15, key: 'b' }],
  ['line', { x1: 10, x2: 8, y1: 3, y2: 21, key: 'c' }],
  ['line', { x1: 16, x2: 14, y1: 3, y2: 21, key: 'd' }],
]);
export const Key = createWpIcon('Key', [
  ['path', { d: 'm15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4', key: 'a' }],
  ['path', { d: 'm21 2-9.6 9.6', key: 'b' }],
  ['circle', { cx: 7.5, cy: 15.5, r: 5.5, key: 'c' }],
]);
export const Lock = createWpIcon('Lock', [
  ['rect', { width: 18, height: 11, x: 3, y: 11, rx: 2, ry: 2, key: 'a' }],
  ['path', { d: 'M7 11V7a5 5 0 0 1 10 0v4', key: 'b' }],
]);
export const Shield = createWpIcon('Shield', [
  ['path', { d: 'M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z', key: 'a' }],
]);
export const ShieldCheck = createWpIcon('ShieldCheck', [
  ['path', { d: 'M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z', key: 'a' }],
  ['path', { d: 'm9 12 2 2 4-4', key: 'b' }],
]);
export const ShieldOff = createWpIcon('ShieldOff', [
  ['path', { d: 'M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z', key: 'a' }],
  ['line', { x1: 2, x2: 22, y1: 2, y2: 22, key: 'b' }],
]);
